import TermsConditionsSection from "./TermsConditionsSection";

interface TermsConditionsItem {
    title: string
    paragraphs: string[]
}

const TermsConditions = () => {

    const tcItems: TermsConditionsItem[] = [
        {
            title: "Privacy Policy for ACareer",
            paragraphs: [
                "At ACareer, accessible from ACareer.com, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by ACareer and how we use it.",
                "If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us."
            ]
        },
        {
            title: "Privacy Policy for ACareer",
            paragraphs: [
                "ACareer follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information. Our Privacy Policy was created with the help of the Privacy Policy Generator.",
            ]
        },
        {
            title: "Cookies and Web Beacons",
            paragraphs: [
                "Like any other website, ACareer uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed οr visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information. ",
                "For more general information on cookies, please read the 'Cookies' article from the Privacy Policy Generator. "
            ]
        },
        {
            title: "Our Advertising Partners ",
            paragraphs: [
                "Some of advertisers on our site may use cookies and web beacons. Our advertising partners are listed below. Each of our advertising partners has their own Privacy Policy for their policies on user data. For easier access, we hyperlinked to their Privacy Policies below."
            ]
        },
        {
            title: "Third Party Privacy Policies",
            paragraphs: [
                "ACareer's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.",
                "You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites. What Are Cookies?"
            ]
        },
        {
            title: "Children's Information",
            paragraphs: [
                "Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.",
                "ACareer does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information or our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records."
            ]
        },
        {
            title: "Online Privacy Policy Only",
            paragraphs: [
                "This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in ACareer. This policy is not applicable to any information collected offline or via channels other than this website."
            ]
        },
        {
            title: "Consent",
            paragraphs: [
                "By using our website, you hereby consent to our Privacy Policy and agree to its Terms and Conditions."
            ]
        }
    ] 

    return (
        <div className="flex flex-col">
            {
                tcItems.map((item, i) => 
                    <TermsConditionsSection title={item.title} key={`tc_title_${i}`}>
                        {item.paragraphs.map((paragraph, j) => <TermsConditionsSection.Paragraph text={paragraph} key={`tc_title${i}_${j}`} />)}
                    </TermsConditionsSection>
                )
            }
        </div>
    )
}

export default TermsConditions;
